import React from "react";
import DeclarationLayout, { Point } from "./DeclarationLayout";

// Institutional / Organizational (Other) membership declaration & terms
// (opened from the Other membership form).
export default function InstitutionalDeclaration() {
  return (
    <DeclarationLayout
      title="Institutional / Organizational Membership"
      subtitle="Declaration, Terms & Conditions — NSVEC, New Delhi"
      crumbLabel="Institutional Member Declaration"
    >
      <div className="decl-intro">
        I/We, the authorized representative of the institution/organization, hereby
        declare that all information, particulars, records and documents submitted
        for Institutional / Organizational Membership of NSVEC are true, correct and
        complete to the best of our knowledge and belief. The institution agrees to
        comply with the following terms and conditions.
      </div>

      <Point
        heading="1. Accurate Institutional Information"
        en="The institution shall provide accurate and complete information regarding its legal name, registration/incorporation details, year of establishment, registered office, authorized representative, contact details, activities and other information required by NSVEC."
      />
      <Point
        heading="2. Authorized Representative"
        en="The Membership Application shall be submitted by a person duly authorized to represent the institution. The institution shall remain responsible for all declarations and commitments made by its authorized representative."
      />
      <Point
        heading="3. Truthfulness of Information and Documents"
        en="All information, certificates, records and documents submitted by the institution shall be genuine, valid and accurate. Submission of false, forged, misleading or materially incomplete information may result in suspension or cancellation of Membership in accordance with applicable rules and procedure."
      />
      <Point
        heading="4. Legal and Regulatory Compliance"
        en="The institution shall remain responsible for its own registration, constitution, licensing, academic, professional, commercial, administrative and other legal/regulatory compliance. NSVEC Membership shall not replace any statutory registration, license, approval or permission required by law."
      />
      <Point
        heading="5. Scope of Membership"
        en="Institutional Membership represents the Membership status granted by NSVEC under its applicable Membership policy. It shall not, by itself, be represented as a Government appointment, Government license, statutory qualification, statutory recognition, affiliation or approval unless separately and expressly authorized by the competent authority."
      />
      <Point
        heading="6. Use of NSVEC Name, Logo and Membership Credentials"
        en="The institution may use the NSVEC name, logo, Membership Certificate, Membership Number or other official Membership credentials only for authorized purposes and in accordance with NSVEC guidelines. No use shall create a false or misleading impression of Government affiliation, statutory authority, accreditation or recognition."
      />
      <Point
        heading="7. Independent Responsibility of the Institution"
        en="The institution shall remain independently responsible for its academic, training, professional, commercial, employment, administrative and other activities. NSVEC shall not automatically become a party to agreements, services, transactions or commitments made by the institutional member with students, trainees, employees, clients, beneficiaries or third parties."
      />
      <Point
        heading="8. Compliance with NSVEC Policies"
        en="The institutional member shall comply with NSVEC Membership Rules, Policies, Guidelines, Code of Conduct and other applicable instructions issued by NSVEC from time to time."
      />
      <Point
        heading="9. Membership Fee and Renewal"
        en="Application Fee, Membership Fee, Annual/Renewal Fee and other applicable charges shall be payable as prescribed by NSVEC. Membership validity and renewal shall be governed by the applicable Membership Policy."
      />
      <Point
        heading="10. Fee and Refund"
        en="Refund of Application, Membership or other fees shall be governed by the applicable NSVEC Refund Policy. Where Membership is cancelled due to false information, forged documents or other violations, any refund shall be subject to the applicable policy and decision of NSVEC."
      />
      <Point
        heading="11. Verification and Additional Information"
        en="NSVEC may verify the information and documents submitted by the institution and may request additional documents, clarification or supporting records whenever reasonably required for Membership administration or verification."
      />
      <Point
        heading="12. Membership Benefits"
        en="During the valid Membership period, the institutional member may access or participate in Membership-related programmes, seminars, workshops, knowledge-sharing activities, networking opportunities and other benefits as may be offered by NSVEC. Availability shall depend on the applicable Membership category and policy."
      />
      <Point
        heading="13. Duties and Conduct of Institutional Member"
        en="The institution shall maintain the dignity and reputation of NSVEC, shall not make misleading claims, shall not make unauthorized commitments on behalf of NSVEC, and shall not collect money in the name of NSVEC without prior written authorization."
      />
      <Point
        heading="14. Branches, Centres and Associated Entities"
        en="Membership of an institution shall not automatically extend to its branches, centres, franchises, subsidiaries or associated entities unless expressly permitted by NSVEC in writing or covered by the applicable Membership Policy."
      />
      <Point
        heading="15. Suspension of Membership"
        en="NSVEC may suspend Membership in accordance with applicable rules and procedure where the institution submits false information or documents, misuses NSVEC identity, violates Membership Rules, breaches the Code of Conduct, or engages in conduct materially inconsistent with Membership requirements."
      />
      <Point
        heading="16. Cancellation / Termination of Membership"
        en="NSVEC may cancel or terminate Institutional Membership in accordance with applicable rules and procedure in cases of serious violation, fraudulent documentation, unauthorized representation, misuse of NSVEC identity, repeated non-compliance or other substantial grounds. Upon termination, the institution shall cease using NSVEC Membership credentials."
      />
      <Point
        heading="17. Withdrawal / Resignation"
        en="The institution may request withdrawal from Membership by submitting written notice to NSVEC. The effective date and financial consequences of withdrawal shall be governed by the applicable Membership Policy."
      />
      <Point
        heading="18. Confidentiality and Information"
        en="Information submitted for Membership administration may be used for verification, record maintenance, communication and other legitimate Membership-related purposes in accordance with applicable policy and law. The institution shall not disclose confidential or restricted information received from NSVEC without authorization."
      />
      <Point
        heading="19. Non-Transferability"
        en="Institutional Membership is personal to the approved institution and shall not be sold, assigned, transferred or otherwise passed to another person or entity without prior written approval from NSVEC."
      />
      <Point
        heading="20. No Unauthorized Representation"
        en="The institutional member shall not represent itself as a Government Department, Government Authority, statutory authority, official certifying authority or authorized representative of NSVEC unless separate written authorization has been issued by NSVEC."
      />
      <Point
        heading="21. Amendment of Rules"
        en="NSVEC may amend its Membership Rules, Policies, Fee Structure, Benefits and Procedures from time to time, subject to applicable law and any binding written agreement."
      />
      <Point
        heading="22. Grievance / Complaint"
        en="The institution may raise Membership-related complaints, requests or clarifications through the grievance mechanism prescribed by NSVEC."
      />
      <Point
        heading="23. Dispute Resolution and Jurisdiction"
        en="The parties shall first attempt to resolve Membership-related disputes through communication and the applicable grievance/dispute resolution mechanism. If judicial resolution becomes necessary, the matter shall be subject to applicable law and the jurisdiction of the competent court."
      />
      <Point
        heading="24. Governing Law"
        en="Institutional Membership shall be governed by the laws applicable in India, together with the applicable NSVEC Membership Policies and written agreements, to the extent legally permissible."
      />

      <div className="decl-final">
        <h3>25. Final Declaration and Acceptance</h3>
        <p>
          We confirm that the information and documents submitted by our institution
          are true and genuine; the signatory is duly authorized; the above Terms &amp;
          Conditions have been read and understood; and the institution agrees to
          comply with the applicable NSVEC Membership Rules, Policies and Code of
          Conduct.
        </p>
      </div>
    </DeclarationLayout>
  );
}
